"use strict";

class SaleDocumentsController {

    constructor($scope, $window, $timeout, SSAppService, SSHttpService, SSUserService, SSUtilService, SSDateService, SSAlertService, SSConfigService, SSConfirmationService, SSEoiService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.$timeout = $timeout;
        self.SSAppService = SSAppService;
        self.SSHttpService = SSHttpService;
        self.SSUserService = SSUserService;
        self.SSUtilService = SSUtilService;
        self.SSDateService = SSDateService;
        self.SSAlertService = SSAlertService;
        self.SSConfigService = SSConfigService;
        self.SSConfirmationService = SSConfirmationService;

        self.DOWNLOAD_STATUS_IN_PROGRESS = SHOWSUITE.SALE_DOCUMENTS_DOWNLOAD_STATUS_IN_PROGRESS;
        self.DOWNLOAD_STATUS_COMPLETE = SHOWSUITE.SALE_DOCUMENTS_DOWNLOAD_STATUS_COMPLETE;

        self.DATE_FORMATE_DD_MM_YY = SHOWSUITE.DATE_FORMATE_DD_MM_YY;
        self.DATE_FORMATE_MM_DD_YY = SHOWSUITE.DATE_FORMATE_MM_DD_YY;

        //temporary constant created only here
        self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS_PURCHASER = 99999;

        self.data = SHOWSUITE.data;

        self.has_access = false;

        self.message = 'No record found';

        self.user = self.SSUserService.getUser();
        if (!self.user) {
            self.SSUserService.showLoginModal();
        }

        if (self.SSUserService.isDeveloper()
            && self.SSUserService.hasPermission('DMS_SALE_DOCUMENTS_DOWNLOAD_ALL')
        ) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        const self = this;

        self.document_selections = {};
        self.documentParams = {
            sale_dir_ind : 1,
        };
        self.documentErrors = {};
        self.FILE_STATUS = {};

        // WEB-4337: setInterval handles for the per-row expiry countdown, keyed by
        // download id, so a re-fetch (or scope teardown) can clear them instead of
        // stacking another 1s timer on top of the one already ticking for that row.
        self.expiration_timers = {};

        self.initDefaultDocumentKinds();
        self.prepareFileStatuses();
        self.prepareDeveloperProperties();
        self.getSaleDocuments();

        // Disable future date selection
        $('.date-input').datepicker({ maxDate: new Date(), dateFormat: "dd/mm/yy" });

        // WEB-4337: the countdown timers outlive the controller otherwise.
        self.$scope.$on('$destroy', function () {
            self.clearExpirationTimers();
        });
    }

    getSaleDocuments(){
        const self = this;

        // WEB-4337: every fetch re-creates the rows, and each row re-runs
        // ng-init="ctrl.calculateExpiration(document)". Drop the timers of the rows
        // being replaced so they are not left running alongside the new ones.
        self.clearExpirationTimers();

        self.sale_documents = [];

        let url = 'sec/developer/sales/download-sale-docs/get-zip-file-urls';
        let params = {
            include: "developer, user, property"
        }

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if(!response.sub_code == 305027){
                    self.SSAlertService.parseAndDisplayError(response);
                }
                if(response.message === 'No sale documents download request found.'){
                    self.message = response.message;
                }
                return;
            }
            if(response.data && response.data.zip_file_urls && response.data.zip_file_urls.length > 0){
                self.sale_documents = response.data.zip_file_urls;
            }
        });
    }

    onDownloadDocuments(){
        const self = this;

        self.documentParams = {
            sale_dir_ind: 1,
        };
        self.document_selections = {};
        self.updateFilter();

        self.hideModals();
        $("#downloadSaleDocumentModal").modal('show');
    }

    initiateDownload(){
        const self = this;

        self.documentErrors = {};
        if(!self.isValidInput()){
            return;
        }

        self.documentParams.document_kinds = "";

        //add document_type in parameter if one PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS is selected
        if(Object.keys(self.document_selections).length){
            if((SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS in self.document_selections && !(self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS_PURCHASER in self.document_selections)) || (!(SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS in self.document_selections) && self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS_PURCHASER in self.document_selections)){
                self.document_selections[SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS] = true;
                if(SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS in self.document_selections){
                    self.documentParams.document_type = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED;
                }
                if(self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS_PURCHASER in self.document_selections){
                    self.documentParams.document_type = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_FORM;
                }
            }
            delete self.document_selections[self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS_PURCHASER];
        }


        if(Object.keys(self.document_selections).length){
            $.each(self.document_selections, function(index, selected){
                if(selected){
                    self.documentParams.document_kinds += index.toString()+",";
                }
            });
            self.documentParams.document_kinds = self.documentParams.document_kinds.slice(0, -1);
        }

        let url = 'sec/developer/sales/download-sale-docs';

        let params = self.documentParams;

        if(self.documentParams.otp_date_from){
            params.otp_date_from = self.SSDateService.formateWithTimeAsNoon(self.documentParams.otp_date_from);
        }
        if(self.documentParams.otp_date_to){
            params.otp_date_to = self.SSDateService.formateWithTimeAsNoon(self.documentParams.otp_date_to);
        }

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            self.hideModals();
            if(response.sub_code != 921013 && response.sub_code != 921014 && response.sub_code != 921015 ){
                if (response instanceof Error ) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }
            }
            let error_message = "";
            if(response.sub_code == 921013){
                error_message = "Another download request with same criteria already in progress. To send new request please wait until existing is completed. You will be notified via email when current in-progress will be ready to download.";
                self.SSAlertService.warning(response.message? response.message : error_message);
                return;
            }
            else if(response.sub_code == 921014){
                error_message = "No sales found with the given criteria.";
                self.SSAlertService.warning(response.message? response.message : error_message);
                return;
            }
            else if(response.sub_code == 921015){
                error_message = "Download request exceeds the max allowed limit. Please split into multiple requests.";
                self.SSAlertService.warning(response.message? response.message : error_message);
                return;
            }

            if(response.success){
                self.SSAlertService.success('Success!', 'Download process initiated successfully.');

                // WEB-4337: re-fetch the listing instead of appending a hand-built row.
                // This endpoint nests the new record one level deeper (response.data is
                // {zip_file_urls: {...}}), so the appended row had no id / status /
                // created_at / property_id at all: the project cell rendered blank,
                // created_at rendered "null <current time>", and an undefined status threw
                // out of getFileStatusClass() on every dirty-check pass until Angular gave
                // up with $rootScope:infdig - abandoning the digest and leaving the sibling
                // status binding on screen as raw {{ }} text.
                // Un-nesting alone would not be enough either: the create response carries
                // download_details as null (no url / file_size / total_sales_selected) and
                // no property relation. The listing endpoint returns the canonical shape,
                // i.e. exactly what a page refresh renders.
                self.getSaleDocuments();
            }
        });
    }

    isValidInput(){
        const self = this;

        let isValid = true;

        $("#otp_date_from").removeAttr('style');
        $("#otp_date_to").removeAttr('style');

        if(!self.documentParams.property_id){
            self.documentErrors.property_id = "Please select a project";
            isValid = false;
        }
        // User can select one date
        // if(self.documentParams.otp_date_from || self.documentParams.otp_date_to){
        //     // If one date is selected then user must select other as well
        //     if(!self.documentParams.otp_date_from){
        //         $("#otp_date_from").css({'border-color': 'red', 'background-color': 'linen'});
        //         isValid = false;
        //     }
        //     else if(!self.documentParams.otp_date_to){
        //         $("#otp_date_to").css({'border-color': 'red', 'background-color': 'linen'});
        //         isValid = false;
        //     }
        // }

        return isValid;
    }

    downloadFile(url){
        const self = this;

        if(!url){
            console.log("Something wrong with file url.");
            return;
        }

        window.open(url, '_blank');
    }

    /**
     * Format a download request timestamp for display in the listing.
     *
     * @param {string|null} date The UTC timestamp (created_at / completed_at).
     * @returns {string} "DD/MM/YYYY hh:mm A", or '--' when the timestamp is
     *          missing or is the MySQL zero date.
     * @remarks WEB-4337: both date columns must go through this. Concatenating the
     *          two SSUtilService formatters directly is unsafe for a missing date,
     *          because formatUtcToLocalDate() short-circuits to null while
     *          formatUtcToLocalTime() falls through to moment.utc(undefined) - i.e.
     *          "now" - which rendered the literal string "null 03:06 AM".
     */
    getFormattedDateTime(date){
        const self = this;

        if(!date || date.startsWith('0000-00-00')){
            return '--';
        }

        let localDate = self.SSUtilService.formatUtcToLocalDate(date);
        let localTime = self.SSUtilService.formatUtcToLocalTime(date);

        if(!(localDate && localTime)){
            return '--';
        }

        return localDate + " " + localTime;
    }

    getCreatedByName(document){
        const self = this;

        let created_by = document.created_by; 
        let user = document.user;

        var name = '--';

        if(!(created_by && user)){
            return name;
        }

        if(user){
            name = user.display_name ? user.display_name : user.first_name + " " + user.last_name;
        }

        return name;
    }

    prepareDeveloperProperties() {
        const self = this;

        let url = 'sec/developer/properties/list';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.properties = response.data.properties;

            self.$timeout(function () {
                $("select.dashboard-select#property-select").niceSelect('update');
            });
        });
    }

    initDefaultDocumentKinds(){
        const self = this;

        self.document_kinds_list = [
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_PDI_FORM, "name": "Pdi Form"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_SIDE_LETTER, "name": "Side Letter"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTP, "name": "OTP"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_AML, "name": "AML"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEXES, "name": "Annexes"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_A, "name": "Annex A"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_B3, "name": "Annex B3"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_C, "name": "Annex C"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM, "name": "Declaration Form"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM, "name": "Cover Letter Form"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS, "name": "Buyer Particulars (System Generated)"},
          {"kind": self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS_PURCHASER, "name": "Purchaser Particulars Form"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER, "name": "Selections Letter"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_LETTER_OF_AGREEMENT, "name": "Letter of Agreement"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION, "name": "Letter of Authorisation"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER, "name": "Buyer Congratulations Letter"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM, "name": "Elite Membership Form"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_A1, "name": "CDD Form A1"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_A2, "name": "CDD Form A2"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_A3, "name": "CDD Form A3"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_B, "name": "CDD Form B"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_C, "name": "CDD Form C"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_D, "name": "CDD Form D"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_E, "name": "CDD Form E"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_F, "name": "CDD Form F"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_F_A2, "name": "CDD Form F Annexure 2"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_G, "name": "CDD Form G"},
          {"kind": SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTHER, "name": "Other"},
        ];

    }

    /**
     * Resolve the display label of a download status.
     *
     * @param {number|string|null} status_id The download status.
     * @returns {string} The status label, or '--' when the status is unknown.
     * @remarks WEB-4337: must never throw. These helpers are read from an
     *          interpolated attribute on the row, and a throwing watcher throws
     *          again on every dirty-check pass until Angular aborts the digest with
     *          $rootScope:infdig - which leaves the rest of the row's bindings
     *          rendered as raw {{ }} text.
     */
    getFileStatusName(status_id){
        const self = this;

        let status = self.FILE_STATUS[status_id];

        return status ? status.name : '--';
    }

    /**
     * Resolve the CSS class of a download status.
     *
     * @param {number|string|null} status_id The download status.
     * @returns {string} The status css class, or '' when the status is unknown.
     * @remarks WEB-4337: must never throw - see getFileStatusName().
     */
    getFileStatusClass(status_id){
        const self = this;

        let status = self.FILE_STATUS[status_id];

        return status ? status.cssClass : '';
    }

    prepareFileStatuses(){
        const self = this;

        self.FILE_STATUS[self.DOWNLOAD_STATUS_IN_PROGRESS] =  {name:'In Progress', cssClass:'text-warning'};
        self.FILE_STATUS[self.DOWNLOAD_STATUS_COMPLETE] = {name:'Completed', cssClass:'text-success'};
    }

    updateFilter(){
        const self = this;

        self.$timeout(function () {
            $("select.dashboard-select#property-select").niceSelect('update');
        });
    }

    calculateExpiration(document){
        const self = this;

        if(!document){
            return;
        }

        let completed_at = document.completed_at;
        if(!completed_at || completed_at.startsWith('0000-00-00')){
            self.clearExpirationTimer(document.id);
            $(".download_"+document.id).fadeOut('slow');
            return;
        }

        let date = self.SSDateService.toLocalDate(completed_at);
        date.setDate(date.getDate() + 3);
        // Set the date we're counting down to
        var countDownDate = date.getTime();

        self.setExpiration(document, countDownDate);
    }

    setExpiration(document, countDownDate){
        const self = this;

        // WEB-4337: never run two countdowns for the same row (a re-fetch re-runs the
        // ng-init that calls us).
        self.clearExpirationTimer(document.id);

        // Update the count down every 1 second
        var x = setInterval(function() {
            
            // Get today's date and time
            let currentDate = self.SSDateService.toLocalDate(new moment().utc().format('YYYY-MM-DD HH:mm:ss'));

            // Find the difference between now and the count down date
            var difference = countDownDate - currentDate.getTime();

            // If the count down is over, write some text 
            if (difference < 0) {
                self.clearExpirationTimer(document.id);
                $(".download_"+document.id).fadeOut('fast');
                $("#expiration_"+document.id).text("EXPIRED");
                return;
            }

            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(difference / (1000 * 60 * 60 * 24));
            var hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((difference % (1000 * 60)) / 1000);
                
            // Output the result
            $("#expiration_"+document.id).text(days + "d " + hours + "h "
            + minutes + "m " + seconds + "s ");
            
        }, 1000);

        self.expiration_timers[document.id] = x;
    }

    /**
     * Stop the expiry countdown of a single download row.
     *
     * @param {number|string} documentId The download request id.
     * @returns {void}
     * @remarks WEB-4337: safe to call for a row that has no timer.
     */
    clearExpirationTimer(documentId){
        const self = this;

        if(self.expiration_timers && self.expiration_timers[documentId]){
            clearInterval(self.expiration_timers[documentId]);
            delete self.expiration_timers[documentId];
        }
    }

    /**
     * Stop every expiry countdown currently running.
     *
     * @returns {void}
     * @remarks WEB-4337: called before repopulating the listing and on $destroy;
     *          the intervals were previously never cleared, so each fetch stacked
     *          one more 1s timer per completed row.
     */
    clearExpirationTimers(){
        const self = this;

        if(!self.expiration_timers){
            return;
        }

        Object.keys(self.expiration_timers).forEach(function (documentId) {
            self.clearExpirationTimer(documentId);
        });
    }

    hideModals(){
        const self = this;

        if ($('#downloadSaleDocumentModal').is(':visible')) $('#downloadSaleDocumentModal').modal('hide');
    }

    checkThirtyMinuteGone(date) {
        const gmtDate = moment.utc(date);

        if (!gmtDate.isValid()) {
            return false;
        }

        const localDate = gmtDate.local(); // Convert to local time
        const now = moment(); // Current local time
        const diffInMinutes = now.diff(localDate, 'minutes');

        return diffInMinutes > 30;
    }

    deleteSaleDocument(docId) {
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to delete?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/developer/sales/download-sale-docs/delete-zip-file-url';
                let params = {
                    id: docId
                };
                loading(true);
                self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }
                    self.clearExpirationTimer(docId);
                    self.sale_documents = self.sale_documents.filter(doc => doc.id !== docId);
                    self.SSAlertService.success('Success!', 'Download request is deleted successfully.');
                });
            }
        );
    }

}

SaleDocumentsController.$inject = ['$scope', '$window', '$timeout', 'SSAppService', 'SSHttpService', 'SSUserService', 'SSUtilService', 'SSDateService', 'SSAlertService', 'SSConfigService', 'SSConfirmationService', 'SSEoiService'];
app.controller('SaleDocumentsController', SaleDocumentsController);

// WEB-4411/WEB-4414: `datepicker` is registered once, globally, by services/key_handover.js.
// A copy here would link it a second time on every element.